"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableLabel = exports.CollectionModelDrawableLabelMutator = void 0;
var tslib_1 = require("tslib");
var vector_1 = require("../../../math/vector");
var drawable_1 = require("./drawable");
var marker_drawable_1 = require("./marker.drawable");
var marker_offset_drawable_1 = require("./marker.offset.drawable");
var CollectionModelDrawableLabelMutator = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableLabelMutator, _super);
    function CollectionModelDrawableLabelMutator(drawable) {
        return _super.call(this, drawable) || this;
    }
    CollectionModelDrawableLabelMutator.prototype.text = function (text) {
        var state = this.getValue();
        if (text == null) {
            state.text = [];
        }
        else {
            state.text = [text];
        }
        this.setValue(state);
    };
    CollectionModelDrawableLabelMutator.prototype.link = function (field) {
        var state = this.getValue();
        state.links = state.links.slice();
        state.links.push(field.id);
        this.setValue(state);
    };
    CollectionModelDrawableLabelMutator.prototype.unlink = function (fieldId) {
        var state = this.getValue();
        var fieldIdIndex = state.links.indexOf(fieldId);
        if (fieldIdIndex === -1) {
            return;
        }
        state.links = state.links.slice();
        state.links.splice(fieldIdIndex, 1);
        this.setValue(state);
    };
    return CollectionModelDrawableLabelMutator;
}(drawable_1.CollectionModelDrawableMutator));
exports.CollectionModelDrawableLabelMutator = CollectionModelDrawableLabelMutator;
var CollectionModelDrawableLabel = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableLabel, _super);
    function CollectionModelDrawableLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tag = CollectionModelDrawableLabel.TAG;
        _this.Mutator = new CollectionModelDrawableLabelMutator(_this);
        return _this;
    }
    CollectionModelDrawableLabel.state = function (id, parentId) {
        return {
            id: id,
            tag: 'label',
            parentId: parentId,
            text: [],
            links: [],
            x: 0,
            y: 0
        };
    };
    CollectionModelDrawableLabel.isLabel = function (t) {
        return t.state.tag === CollectionModelDrawableLabel.TAG;
    };
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "parent", {
        get: function () {
            var stateValue = this.state;
            if (stateValue.parentId == null) {
                return null;
            }
            return this.drawableState.getDrawable(stateValue.parentId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "text", {
        get: function () {
            if (this.parent != null) {
                if (marker_drawable_1.CollectionModelDrawableMarker.isBase(this.parent)) {
                    if (this.drawableState.baseOffset == null) {
                        return ['Base'];
                    }
                    return ['Base offset'];
                }
                if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(this.parent)) {
                    return ['Base'];
                }
            }
            var state = this.state;
            if (!Array.isArray(state.text)) {
                return [];
            }
            return state.text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "links", {
        /** Only height & vertical separation fields can be linked to */
        get: function () {
            var state = this.state;
            if (!Array.isArray(state.links)) {
                return [];
            }
            var output = [];
            var collection = this.drawableState.collection;
            for (var _i = 0, _a = state.links; _i < _a.length; _i++) {
                var link = _a[_i];
                var collectionField = collection.findField(link);
                if (collectionField == null) {
                    continue;
                }
                output.push(collectionField);
            }
            return output;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLabel.prototype.getVector = function () {
        return new vector_1.Vector(this.state.x, this.state.y);
    };
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "isInsightMeasurement", {
        get: function () {
            var _a;
            return !!((_a = this.state) === null || _a === void 0 ? void 0 : _a.insight) && !this.state.insight.applied;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLabel.TAG = 'label';
    return CollectionModelDrawableLabel;
}(drawable_1.CollectionModelDrawable));
exports.CollectionModelDrawableLabel = CollectionModelDrawableLabel;
//# sourceMappingURL=label.drawable.js.map